import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { IS_FEMALE } from "@/constants/isFemale";
import { Routes as AppRoutes } from "@/constants/routes";

const COOKIEYES_SCRIPT_ID = "cookieyes";

const COOKIEYES_MALE_DOMAIN_ID = "0f58950508eda231e41854e73bc5619b";
const COOKIEYES_FEMALE_DOMAIN_ID = "59315b145fac8b392596b1c0d84970b8";

const COOKIEYES_DOMAIN_ID = IS_FEMALE ? COOKIEYES_FEMALE_DOMAIN_ID : COOKIEYES_MALE_DOMAIN_ID;

const useCookieYesLoader = () => {
    const location = useLocation();

    useEffect(() => {
        const isFunnelFox = location.pathname.includes(AppRoutes.FFPaywall);
        const existingScript = document.getElementById(COOKIEYES_SCRIPT_ID);

        if (isFunnelFox || existingScript) return;

        const script = document.createElement("script");
        script.id = COOKIEYES_SCRIPT_ID;
        script.src = `https://cdn-cookieyes.com/client_data/${COOKIEYES_DOMAIN_ID}/script.js`;
        script.type = "text/javascript";

        document.head.appendChild(script);
    }, [location.pathname]);
};

export default useCookieYesLoader;
